
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/experiences",
      function () {
        return require("private-next-pages/experiences/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/experiences"])
      });
    }
  